module.exports = __webpack_public_path__ + "img/MTABAPPBP.c700aef3.jpg";